import React, { useState, useMemo } from "react";
import { Slider, Form } from "antd";
import type { SliderSingleProps } from "antd";

interface DynamicSliderProps {
  allowedValues: number[]; // e.g., [0, 26, 37, 100]
  defaultValue?: number;
  name?: string;
  onChange?: (value: number) => void;
}

const DynamicSlider: React.FC<DynamicSliderProps> = ({
  allowedValues,
  defaultValue,
  name,
  onChange,
}) => {
  // Ensure values are sorted
  const sortedValues = useMemo(
    () => [...allowedValues].sort((a, b) => a - b),
    [allowedValues]
  );

  const [value, setValue] = useState<number>(
    defaultValue ?? sortedValues[0]
  );

  const handleChange = (val: number) => {
    setValue(val);
    onChange?.(val);
  };

  const marks: SliderSingleProps["marks"] = useMemo(() => {
    const result: SliderSingleProps["marks"] = {};
    sortedValues.forEach((val) => {
      result[val] = `${val}°C`;
    });
    return result;
  }, [sortedValues]);

  return (
    <>
      {/* <p>Current Value: {value}</p> */}
      <Form.Item name={name} label={name}>
        <Slider
          min={sortedValues[0]}
          max={sortedValues[sortedValues.length - 1]}
          step={null} // Only snap to marks
          marks={marks}
          value={value}
          onChange={handleChange}
        />
      </Form.Item>
    </>
  );
};

export default DynamicSlider;
